
// Function to set the font family based on app name
export const setRootCSSTheme = () => {
  const appName = import.meta.env.VITE_APP_NAME?.toLowerCase() || "";
  const root = document.documentElement;

  if (appName.includes("a23")) {
    root.setAttribute("data-theme", "a23");
  } else {
    // Default to Adda font family
    root.setAttribute("data-theme", "a52");
  }

};
